import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { DateRangeCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { DatePickerComponent } from '../date-picker/date-picker.component';

@Component({
  selector: 'lib-date-range-parent',
  templateUrl: './date-range-parent.component.html',
  styleUrls: ['./date-range-parent.component.css']
})
export class DateRangeParentComponent implements OnInit {

  @ViewChild('fromDatePicker', { static: true }) fromDatePicker: DatePickerComponent;
  @ViewChild('toDatePicker', { static: true }) toDatePicker: DatePickerComponent;


  public utilityobj: DateRangeCIF;
  message: any;
  public form: UntypedFormGroup;
  public datecompare = false;

  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.utilityobj = new DateRangeCIF();
    //console.log(`DateRangeParent utilityobj: ${JSON.stringify(this.utilityobj)}`);
    this.store.select(getRegSearchState).subscribe(data => this.message = data);
      if (this.message.date.date.length != 0) {
        this.utilityobj.fromDate = this.message.date.date[0].fromDate;
        this.utilityobj.toDate = this.message.date.date[0].toDate;
      }

  }

  ngOnInit() {
    this.form = this.fb.group({
    });
    this.form.valueChanges.subscribe(value => {
      //console.log(`------------DateRangeParent ValueChanges Fired`);
      //console.log(`value: ${JSON.stringify(value)}`);
    });
  }

  ngAfterViewInit() {
    
    this.form.addControl('datefrom', this.fromDatePicker.form);
    this.fromDatePicker.form.setParent(this.form);
    this.fromDatePicker.value = this.utilityobj.fromDate;
    this.fromDatePicker.valueChange.subscribe(value => { this.utilityobj.fromDate = value });

    this.form.addControl('dateto', this.toDatePicker.form);
    this.toDatePicker.form.setParent(this.form);
    this.toDatePicker.value = this.utilityobj.toDate;
    this.toDatePicker.valueChange.subscribe(value => { this.utilityobj.toDate = value });

    this.form.setValidators(this.dateCompareValidator);
    this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });

    //console.log(`-------------------End of ngAfterViewInit`);
    //console.log(`this.form: ${this.form}`);
  }

  dateCompareValidator(control: UntypedFormGroup): ValidationErrors | null {
    //console.log('+++++++++dateCompareValidator fired');
  const FromDate = new Date(control.get('datefrom').get('datebox').value);
    //console.log(`FromDate: ${FromDate}`);
    const ToDate = new Date(control.get('dateto').get('datebox').value);
    //console.log(`ToDate: ${ToDate}`);
    const currDate = new Date();
    if (control.get('datefrom').get('datebox').touched && control.get('dateto').get('datebox').touched) {
      if (FromDate > currDate)
        return { 'fromdatefuture': true }
      else if (FromDate > ToDate && FromDate < currDate && ToDate < currDate) {
        return { datecompare: true }
      }
    }

    else if (FromDate > currDate)
      return { 'fromdatefuture': true }
    else
      return null;
  };

}
